<template>
    <v-container class="inner-main pt-2 mb-10">
        <v-row class="mx-0">
            <h2>{{ $t('global.menu.backoffice.labelCategories') }}</h2>
        </v-row>
        <v-row class="mb-3">
            <v-data-table-server v-model:items-per-page="itemsPerPage" :items-per-page-options="pageOptions"
                density="compact" :headers="headers" :items="serverItems" :items-length="totalItems" :loading="loading"
                :search="search" item-value="id" @update:options="loadItems" @update:page="updatePage" height="60vh"
                :update:sortBy="updateSortBy" :mobile="['xs', 'sm', 'md'].includes($globalState.screenWidth)"
                class="shop-list-table" fixed-header>
                <template v-slot:top>
                    <v-row>
                        <v-col>
                            <!-- TODO BACKEND SEARCH FUNCTION PAGINATION -->
                            <v-text-field v-model="search" :disabled="false"
                                :placeholder="$t('main.search.placeholder')" variant="outlined" hide-details="true"
                                density="compact" class="pb-2 py-0 bg-white" height="32px">
                                <template v-slot:append-inner>
                                    <v-icon icon="mdi-magnify"></v-icon>
                                </template>
                            </v-text-field>
                        </v-col>
                        <v-col cols="4" class="text-right">
                            <v-btn color="primary" variant="flat" class="mr-1" rounded="xl" size="large"
                                @click="createLabelCategory">
                                {{ $t('global.menu.backoffice.createLabelCategory') }}
                            </v-btn>
                        </v-col>
                    </v-row>
                </template>

                <template v-slot:[`item.translations`]="props">
                    {{ props.item.translations ? props.item.translations[selectedLanguage.toUpperCase()].value :
                        props.item.name }}
                </template>
                <template v-slot:[`item.controls`]="props">
                    <v-btn color="primary" variant="flat" size="32" class="mr-1"
                        @click="() => editLabelCategory(props.item)">
                        <v-icon>mdi-pencil</v-icon>
                    </v-btn>
                    <v-btn color="error" variant="flat" size="32" class="mr-1"
                        @click="() => removeLabelCategory(props.item)">
                        <v-icon>mdi-trash-can-outline</v-icon>
                    </v-btn>
                </template>

            </v-data-table-server>
        </v-row>
        <CreateLabelCategoryDialog v-model="showDialog" v-model:data="newLabelCategory" :save="save">
        </CreateLabelCategoryDialog>
        <CustomConfirmDeletionDialog v-model="showDeleteDialog" :confirm-deletion="deleteLabelCategory"
            v-model:data="removedLabelCategory" :title="'Delete Label Category'"
            :question="'Are you sure you want to Delete ?'">
        </CustomConfirmDeletionDialog>
    </v-container>
</template>

<script>
import { ref, inject, getCurrentInstance, nextTick } from 'vue';
import { useRouter } from 'vue-router';
import { useI18n } from 'vue-i18n';
import CreateLabelCategoryDialog from './modals/CreateLabelCategoryDialog.vue';
import CustomConfirmDeletionDialog from './modals/CustomConfirmDeletionDialog.vue';

export default {
    components: {
        CreateLabelCategoryDialog,
        CustomConfirmDeletionDialog
    },
    setup() {

        const { proxy } = getCurrentInstance();
        const router = useRouter();
        const selectedLanguage = localStorage.getItem('selectedLanguage');
        const { t, locale } = useI18n();
        const newLabelCategory = ref({})
        const removedLabelCategory = ref({})
        const showDialog = ref(false)
        const showDeleteDialog = ref(false)
        const softToken = localStorage.getItem("softToken");
        const hardToken = localStorage.getItem("hardToken");
        const username = localStorage.getItem("username");

        const updatePage = (newPage) => {
            proxy.page = newPage;
        }
        const updateSortBy = (newSort) => {
            proxy.sortBy = newSort;
        }

        const editLabelCategory = (item) => {
            newLabelCategory.value = { ...item };
            showDialog.value = true;
        }

        const createLabelCategory = () => {
            showDialog.value = true;
        }

        const save = async () => {
            if (newLabelCategory.value.id) {
                const copy = { ...newLabelCategory.value }
                try {
                    const response = await proxy.$axios.put(`/backoffice/labelcategories/${newLabelCategory.value.id}`, copy, {
                        headers: {
                            'X-Auth-HARDTOKEN': hardToken,
                            'X-Auth-SOFTTOKEN': softToken,
                            'X-Auth-USER': username
                        },
                    });

                    if (response.data.status == "OK") {
                        showDialog.value = false;
                        proxy.loadItems({ page: proxy.page, itemsPerPage: proxy.itemsPerPage, sortBy:proxy.sortBy });
                    }
                } catch (error) {
                    console.error("Error fetching search results:", error);
                }
            } else {
                const copy = { ...newLabelCategory.value }

                try {
                    const response = await proxy.$axios.post(`/backoffice/labelcategories`, copy, {
                        headers: {
                            'X-Auth-HARDTOKEN': hardToken,
                            'X-Auth-SOFTTOKEN': softToken,
                            'X-Auth-USER': username
                        },
                    });

                    if (response.data.status == "OK") {
                        showDialog.value = false;
                        proxy.loadItems({ page: proxy.page, itemsPerPage: proxy.itemsPerPage, sortBy:proxy.sortBy });
                    }
                } catch (error) {
                    console.error("Error fetching search results:", error);
                }
            }
            //{id: "1257e4a6-b4ed-45d9-9723-b31b735eaf8c",frontendId:1, name: "MENSCHENFREUND:", translations: {,…},…} PUT /api/backoffice/labelcategories/1257e4a6-b4ed-45d9-9723-b31b735eaf8c 
            // /api/backoffice/labelcategories POST {name: "TEST", translations: {DE: {value: "TESTDE"}, EN: {value: "TESTEN"}}, frontendId: 5000}
        }
        const removeLabelCategory = async (item) => {

            removedLabelCategory.value = item;
            showDeleteDialog.value = true;
            console.log(removedLabelCategory.value);
        }
        const deleteLabelCategory = async (item) => {
            // DELETE /backoffice/labelcategories/09006201-aab0-48ed-8dc0-b01b618eb119
            try {
                const response = await proxy.$axios.delete(`/backoffice/labelcategories/${item.id}`, {
                    headers: {
                        'X-Auth-HARDTOKEN': hardToken,
                        'X-Auth-SOFTTOKEN': softToken,
                        'X-Auth-USER': username
                    },
                });

                if (response.data.status == "OK") {
                    showDeleteDialog.value = false;
                    proxy.loadItems({ page: proxy.page, itemsPerPage: proxy.itemsPerPage, sortBy:proxy.sortBy });
                }
            } catch (error) {
                console.error("Error fetching search results:", error);
            }
        }

        return {
            selectedLanguage,
            newLabelCategory,
            showDialog,
            editLabelCategory,
            createLabelCategory,
            save,
            deleteLabelCategory,
            removedLabelCategory,
            showDeleteDialog,
            removeLabelCategory,
            updatePage,
            updateSortBy
        };
    },

    watch: {

    },

    data: () => ({
        page: 1,
        itemsPerPage: 50,
        sortBy: [],
        pageOptions: [
            { value: 50, title: '50' },
            { value: 100, title: '100' },
            { value: -1, title: '$vuetify.dataFooter.itemsPerPageAll' }
        ],
        headers: [
            { title: 'Name', key: 'translations', align: 'start', maxWidth: "200px" },
            { title: 'FrontendId', key: 'frontendId', align: 'start' },
            { title: 'Actions', value: "controls", align: 'end', sortable: false },
        ],
        search: '',
        serverItems: [],
        loading: true,
        totalItems: 0,
    }),

    computed: {
    },

    mounted() {
    },

    methods: {
        loadItems({ page, itemsPerPage, sortBy }) {
            this.loading = true
            // console.log(this.selectedLanguage.toUpperCase())
            const hardToken = localStorage.getItem("hardToken");
            const username = localStorage.getItem("username");
            this.$axios.get(this.search.length >= 1 ? "/backoffice/labelcategories/query" : "/backoffice/v2/labelcategories", {
                headers: {
                    'X-Auth-HARDTOKEN': hardToken,
                    'X-Auth-USER': username
                },
                params: {
                    lang: this.selectedLanguage.toUpperCase(),
                    sortDirection: sortBy[0]?.order.toUpperCase(),
                    ...(this.search.length >= 1 ? { search: this.search, resultsPerPage: itemsPerPage, page: page - 1, sortColumn: sortBy[0]?.key, } : { page: page - 1, resultsPerPage: itemsPerPage, sortColumn: sortBy[0]?.key })
                }
            })
                .then(this.itemsFetched)
                .catch(error => {
                    console.error("Error fetching user data:", error);
                    // You can handle specific error codes here, for example, a 401 Unauthorized
                    if (error.response && error.response.status === 401 || error.response.status === 403) {
                        // Handle token expiration or unauthorized error
                        console.log("Session expired or unauthorized. Please log in again.");
                        // Optionally log the user out or redirect to login page
                    }
                });
        },
        itemsFetched(response) {
            console.log(response)
            this.serverItems = response.data.data;
            this.totalItems = response.data.totalElements
            this.loading = false
        }
    },
}
</script>

<style scoped>
.inner-main {
    margin-left: auto;
    margin-right: auto;
    max-width: 1170px;
    margin-top: 40px;
}
</style>

<style></style>

<style></style>